import React, { useState } from "react";

import Base from "./Base";
import ColorElement from "./ColorElement";
import "../styles.css";

const ColorList = () => {
  const [state, setState] = useState({ value: "", copied: false });
  const onClickHandler = (props) => {
    setState({ copied: true });
  };

  return (
    <Base title="UI Color Treasure" className="text-light text-center ">
      <div className="container mb-5">
        <div className="content" style={{ fontFamily: "-moz-initial" }}>
          {state.copied ? (
            <script>
              {" "}
              function myFunction(){" "}
              {alert(
                "Hex code is copied on your clipboard. Now, you can use it."
              )}{" "}
            </script>
          ) : null}
          {state.copied ? (
            <span
              className="bg-success"
              style={{
                color: "white",
                fontSize: "5vmin",
                borderRadius: "5vmin",
              }}
            >
              &nbsp; Hex Code Copied &nbsp;
            </span>
          ) : (
            <span
              style={{
                color: "white",
                background: "#F4BE2C",
                fontSize: "5vmin",
                borderRadius: "5vmin",
              }}
            >
              &nbsp; Just a click to copy &nbsp;
            </span>
          )}
        </div>
      </div>
      <br />
      <h3
        className="text-left mt-4 text-white"
        style={{ marginLeft: "7vmin", fontSize: "5vmin" }}
      >
        Base Colors
      </h3>
      <hr
        height="2rem"
        style={{
          background: "white",
          marginLeft: "7vmin",
          marginRight: "11.5vmin",
        }}
      />
      <br />
      <div>
        <div
          className="row  "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#CAD5E2" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#35BDD0" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#0D0D0D" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#FF6666" onClick={onClickHandler} />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#758283" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#242B2E" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#E03B8B" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#E07C24" onClick={onClickHandler} />
          </div>
        </div>
      </div>
      <br />
      <br />
      <h3
        className="text-left mt-4 text-warning"
        style={{ marginLeft: "7vmin", fontSize: "5vmin" }}
      >
        Yellow Shades
      </h3>
      <hr
        className="bg-warning"
        height="2rem"
        style={{
          marginLeft: "7vmin",
          marginRight: "11.5vmin",
        }}
      />
      <br />
      <div>
        <div
          className="row  "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#E8BD0D" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#EDBF69" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#F4BE2C" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#EDC126" onClick={onClickHandler} />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#E5D68A" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#DDD101" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#D9D55B" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#F7CD2E" onClick={onClickHandler} />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#AF9D5A" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#C7C11A" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#F4CE6A" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#A77B06" onClick={onClickHandler} />
          </div>
        </div>
      </div>
      <br />
      <br />
      <h3
        className="text-left mt-4 text-success"
        style={{ marginLeft: "7vmin", fontSize: "5vmin" }}
      >
        Green Shades
      </h3>
      <hr
        className="bg-success"
        height="2rem"
        style={{
          marginLeft: "7vmin",
          marginRight: "11.5vmin",
        }}
      />
      <br />
      <div>
        <div
          className="row  "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#1FAA59" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#38CC77" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#02B290" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#50DBB4" onClick={onClickHandler} />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#3DBE29" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#4DD637" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#1C8D73" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#66AD47" onClick={onClickHandler} />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#6AC47E" onClick={onClickHandler} />
          </div>
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#6EC72D" onClick={onClickHandler} />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#22CB5C" onClick={onClickHandler} />
          </div>
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement text="#00D84A" onClick={onClickHandler} />
          </div>
        </div>
      </div>
      <br />
      <br />
      <h3
        className="text-left mt-4 text-info"
        style={{ marginLeft: "7vmin", fontSize: "5vmin" }}
      >
        Blue Shades
      </h3>
      <hr
        className="bg-info"
        height="2rem"
        style={{
          marginLeft: "7vmin",
          marginRight: "11.5vmin",
        }}
      />
      <br />
      <div>
        <div
          className="row  "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#1B98F5"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#23C4ED"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3" style={{ height: "100%" }}>
            <ColorElement
              text="#383CC1"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#12B0E8"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#51E1ED"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#207398"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#46B2E0"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#3944F7"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#2827CC"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#120E43"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#5DA3FA"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#03203C"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>
        </div>
      </div>
      <br />
      <br />
      <h3
        className="text-left mt-4 text-danger  "
        style={{ marginLeft: "7vmin", fontSize: "5vmin" }}
      >
        Red Shades
      </h3>
      <hr
        className="bg-danger"
        height="2rem"
        style={{
          marginLeft: "7vmin",
          marginRight: "11.5vmin",
        }}
      />
      <br />
      <div>
        <div
          className="row "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#FF6263"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#DE4839"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#BF3325"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#E21717"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#BF3312"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3" style={{ height: "100%" }}>
            <ColorElement
              text="#D82E2F"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#EB4D4B"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#EF5354"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>
        </div>
        <div
          className="row mt-4 "
          style={{
            marginBottom: "3.7vmin",
            width: "95%",
            margin: "auto",
          }}
        >
          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#B4161B"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#E6425E"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#E83A59"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>

          <div className="col-3 " style={{ height: "100%" }}>
            <ColorElement
              text="#B9345A"
              onClick={onClickHandler}
              className="text-white"
            />
          </div>
        </div>
      </div>
    </Base>
  );
};
export default ColorList;
